import { ConfigService } from "./../../services/config.service";
import { TranslateService } from "@ngx-translate/core";
import { ActivatedRoute } from "@angular/router";
import { CompanyList } from "src/app/models/company-list";
import { AccountService } from "src/app/services/account.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { environment } from "src/environments/environment";
import { SignalRService } from "src/app/services/signalr.service";
import { CompanyNews } from "src/app/models/company-news";
import { SlickCarouselComponent } from "ngx-slick-carousel";
import { UrlConstants } from "src/app/models/urlConstants";
import { ApiService } from "src/app/services/api.service";
declare const TradingView: any;

@Component({
  selector: "app-global-markets",
  templateUrl: "./global-markets.component.html",
  styleUrls: ["./global-markets.component.scss"],
})
export class GlobalMarketsComponent implements OnInit, AfterViewInit {
  symbolCode: any;
  company: CompanyList;
  reuters: any;

  news: CompanyNews[];
  majorIndexes: any[];
  middleEastIndexes: any[];
  exchangeRates: any[];
  gdrData: any[];
  isDarkTheme: boolean;

  @ViewChild("slickModal") slickModal: SlickCarouselComponent;
  @ViewChild("tradingview") tradingview?: ElementRef;
  metalsData: any[];

  constructor(
    private http: HttpClient,
    private accService: AccountService,
    signalService: SignalRService,
    public translate: TranslateService,
    private apiService: ApiService,
    private _renderer2: Renderer2
  ) {
    signalService.marketChanges.subscribe((res: any) =>
      res.forEach((element) => {
        if (element.SymbolCode == this.symbolCode) {
          this.company = element;
          // this.fetchCompany();
          return;
        }
      })
    );
    this.apiService.fetchMarketNews().subscribe((res) => {
      this.news = res;
    });
    this.apiService.fetchMajorIndexes().subscribe((res) => {
      this.majorIndexes = res;
    });
    this.apiService.fetchMiddleEastIndexes().subscribe((res) => {
      this.middleEastIndexes = res;
    });
    this.apiService.fetchExchangeRates().subscribe((res) => {
      this.exchangeRates = res;
    });
    this.apiService.fetchGDR().subscribe((res) => {
      this.gdrData = res;
      this.gdrData.pop();
    });
    this.apiService.fetchMetals().subscribe((res) => {
      this.metalsData = res;
    });
  }

  metalColor(symbol) {
    switch (symbol) {
      case "GOLD":
        return "#DAA520";
      case "SILVER":
        return "#C0C0C0";
      case "PLATINUM":
        return "#e5e4e2";
      case "COPPER":
        return "#B87333";
    }
  }

  slideConfig = {
    cssEase: "linear",
    slidesToShow: 5.5,
    slidesToScroll: 1,
    dots: true,
    width: "50%",
  };

  ngOnInit(): void {
    this.isDarkTheme =
      localStorage.getItem("darktheme") == "dark" ? true : false; }

  ngAfterViewInit() {
    this.renderIndexData("DIA");

    let script = this._renderer2.createElement("script");
    script.type = `text/javascript`;
    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-forex-heat-map.js";
    script.text = `{
      "width": "100%",
      "height": "400",
      "currencies": [
        "EUR",
        "USD",
        "JPY",
        "GBP",
        "CHF",
        "AUD",
        "CAD",
        "NZD",
        "CNY"
      ],
      "isTransparent": false,
      "colorTheme":  "${this.isDarkTheme ? "dark" : "light"}",
      "locale": "${this.translate.currentLang == "ar" ? "ar_AE" : "en"}"
    }`;

    this.tradingview?.nativeElement.appendChild(script);
  }

  renderIndexData(symbol) {
    new TradingView.widget({
      width: "100%",
      height: 400,
      symbol: symbol,
      // interval: "D",
      timezone: "Africa/Cairo",
      theme: this.isDarkTheme ? "Dark" : "Light",
      style: "3",
      locale: this.translate.currentLang == "ar" ? "ar_AE" : "en",
      // toolbar_bg: "#f1f3f6",
      // enable_publishing: false,
      // withdateranges: true,
      // range: "ytd",
      hide_side_toolbar: true,
      hide_top_toolbar: true,
      // allow_symbol_change: true,
      // show_popup_button: true,
      // popup_width: "1000",
      // popup_height: "650",
      // no_referral_id: true,
      container_id: "tradingview_bac65",
    });
  }

  fetchCompany() {
    this.http
      .get(
        `${UrlConstants.feedUrl}/api/Feed/GetMarketWatchForSymbol?SYMBOL_CODE=` +
        this.symbolCode
      )
      .subscribe((res) => {
        this.company = res as CompanyList;
      });
  }
}
